import { Container } from '@hover/blueprint';
import React from 'react';
import ClaimsEstimationDesktop from './ClaimsEstimationDesktop';
import ClaimsEstimationMobile from './ClaimsEstimationMobile';

const InsuranceClaimsEstimation: React.FC = () => (
  <Container maxW="1200px" px={500} mb={1100}>
    <ClaimsEstimationDesktop />
    <ClaimsEstimationMobile />
  </Container>
);

export default InsuranceClaimsEstimation;
